import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Text, Button } from 'react-native-paper';
import { Ionicons } from '@expo/vector-icons';

interface ErrorMessageProps {
  message: string;
  onRetry?: () => void;
  retryText?: string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message,
  onRetry,
  retryText = 'Try Again',
}) => {
  return (
    <View style={styles.container}>
      <Ionicons name='alert-circle-outline' size={48} color='#F44336' />
      <Text variant='headlineSmall' style={styles.title}>
        Something went wrong
      </Text>
      <Text variant='bodyMedium' style={styles.message}>
        {message}
      </Text>
      {onRetry && (
        <Button mode='contained' onPress={onRetry} style={styles.retryButton}>
          {retryText}
        </Button>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  title: {
    marginTop: 16,
    marginBottom: 8,
    textAlign: 'center',
  },
  message: {
    textAlign: 'center',
    marginBottom: 24,
    color: '#666',
  },
  retryButton: {
    marginTop: 8,
  },
});
